// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa-phone-slash {
  position: relative;
  display: inline-block;
}

.fa-phone-slash:before {
  content: "\\f095";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}

.fa-phone-slash:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 10%;
  width: 110%;
  height: 2px;
  background-color: red;
  transform: rotate(45deg);
}

.fa-flip-horizontal {
  transform: scaleX(-1);
}

.tooltip_ustas .phone_success {
  color: var(--colorSuccess);
}

.tooltip_ustas .phone_error {
  color: var(--colorFalseValue);
}

.tooltip_ustas {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.tooltip_ustas .tooltiptext {
  visibility: hidden;
  text-align: center;
  border-radius: 3px;
  padding: 2px 3px;
  position: absolute;
  z-index: 1;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
  font-size: 12px;
  width: auto;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip_ustas .success {
  color: var(--colorTextOnStatus);
  background-color: var(--colorSuccess);
}

.tooltip_ustas .error {
  color: var(--colorTextOnStatus);
  background-color: var(--colorError);
}

.tooltip_ustas .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 1px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltip_ustas:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
